import '@testing-library/jest-dom';
import { fireEvent, render, screen } from '@testing-library/react';

import type { TimelineItemProps } from './Timeline';

import { MOCK_TIMELINE_ITEM } from './mockTimelineItem';

import { Timeline } from 'components';

describe('should render', () => {
  it('should render completed items', () => {
    render(
      <Timeline
        timelineData={MOCK_TIMELINE_ITEM as TimelineItemProps[]}
        showLabel="Toon vervolgstappen"
        hideLabel="Verberg vervolgstappen"
      />
    );
    expect(screen.getByText('Concept')).toBeInTheDocument();
    expect(screen.getByText('Vakgegevens afgewezen')).toBeInTheDocument();
    expect(screen.getByText('Geverifieerd 1 van 3')).toBeInTheDocument();
    expect(screen.getByText('Concept ingediend')).toBeInTheDocument();
    expect(screen.getByText('Aangemaakt')).toBeInTheDocument();
  });

  it('should switch label when button is clicked', () => {
    render(
      <Timeline
        timelineData={MOCK_TIMELINE_ITEM as TimelineItemProps[]}
        showLabel="Toon vervolgstappen"
        hideLabel="Verberg vervolgstappen"
      />
    );
    const button = screen.getByRole('button', { name: 'Toon vervolgstappen' });
    expect(button).toBeInTheDocument();
    fireEvent.click(button);
    expect(screen.getByText('Verberg vervolgstappen')).toBeInTheDocument();
  });

  it('should show incomplete tasks if button is clicked', () => {
    render(
      <Timeline
        timelineData={MOCK_TIMELINE_ITEM as TimelineItemProps[]}
        showLabel="Toon vervolgstappen"
        hideLabel="Verberg vervolgstappen"
      />
    );
    const button = screen.getByRole('button', { name: 'Toon vervolgstappen' });
    expect(button).toBeInTheDocument();
    fireEvent.click(button);
    expect(screen.getByText('Verberg vervolgstappen')).toBeInTheDocument();
    expect(screen.getByText('Actief')).toBeInTheDocument();
  });

  it('should not show button if there are no incomplete tasks', () => {
    render(
      <Timeline
        timelineData={(MOCK_TIMELINE_ITEM as TimelineItemProps[]).filter(({ completed }) => completed)}
        showLabel="Toon vervolgstappen"
        hideLabel="Verberg vervolgstappen"
      />
    );
    expect(screen.queryByText('Toon vervolgstappen')).not.toBeInTheDocument();
  });
});
